import React, { memo } from "react";

import { getCloudinaryUrl, LottieAnimation, useEffectOnce } from "@swiggy-private/core-ui";
import { SPLIT_BILL_WIDGET_LOTTIE_PROPS } from "@dineout-payment-success-ui/constants";

import { SplitBillWidgetLottieWrapper } from "./styles";

interface SplitBillWidgetLottieProps {
    widgetLottieId: string;
    onClick: VoidFunction;
    onImpression?: VoidFunction;
    isClickable?: boolean;
}

const SplitBillWidgetLottie: React.FC<SplitBillWidgetLottieProps> = ({
    widgetLottieId,
    onClick,
    onImpression,
    isClickable = true,
}) => {
    useEffectOnce(() => {
        onImpression?.();
    });

    return (
        <SplitBillWidgetLottieWrapper isClickable={isClickable} onClick={isClickable ? onClick : undefined}>
            <LottieAnimation
                key={widgetLottieId}
                {...SPLIT_BILL_WIDGET_LOTTIE_PROPS}
                fileName={getCloudinaryUrl(widgetLottieId)}
                visible={true}
                playLottie
                preserveAspect="xMidYMid slice"
            />
        </SplitBillWidgetLottieWrapper>
    );
};

export default memo(SplitBillWidgetLottie);
